import { render, staticRenderFns } from "./GoogleIdentity.vue?vue&type=template&id=6bdcbc5c&"
import script from "./GoogleIdentity.vue?vue&type=script&lang=js&"
export * from "./GoogleIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports